import { render, staticRenderFns } from "./dj-collection.vue?vue&type=template&id=7697fce0&scoped=true&"
import script from "./dj-collection.vue?vue&type=script&lang=js&"
export * from "./dj-collection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7697fce0",
  null
  
)

export default component.exports